import { Button, Tag, Typography } from 'antd';
import { formatVND } from '@/utils/format';
import type { ComboSuggestion } from '../utils/comboMatcher';

const { Text } = Typography;

interface Props {
  suggestion: ComboSuggestion;
  onApply: (suggestion: ComboSuggestion) => void;
  onDismiss: (suggestion: ComboSuggestion) => void;
}

/** Banner gợi ý gộp combo — đặt trên đầu giỏ hàng, trên bảng hàng. */
export function ComboSuggestBanner({ suggestion, onApply, onDismiss }: Props) {
  return (
    <div
      data-testid="pos-combo-suggest"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        background: '#fff6f8',
        border: '1px solid #f0c4d0',
        borderLeft: '3px solid #a4193d',
        borderRadius: 5,
        padding: '8px 11px',
        margin: '0 12px 6px',
        flexShrink: 0,
      }}
    >
      <Tag color="#a4193d" style={{ margin: 0, fontSize: 10, fontWeight: 700 }}>
        COMBO
      </Tag>
      <Text style={{ fontSize: 13 }}>
        Gộp được{' '}
        <Text strong>
          {suggestion.unit_count}× {suggestion.combo_name}
        </Text>{' '}
        — tiết kiệm{' '}
        <Text strong style={{ color: '#a4193d' }}>
          {formatVND(suggestion.saving)}
        </Text>
      </Text>
      <div style={{ marginLeft: 'auto', display: 'flex', gap: 6 }}>
        <Button size="small" data-testid="pos-combo-dismiss-btn" onClick={() => onDismiss(suggestion)}>
          Bỏ qua
        </Button>
        <Button
          size="small"
          type="primary"
          data-testid="pos-combo-apply-btn"
          style={{ background: '#a4193d', borderColor: '#a4193d' }}
          onClick={() => onApply(suggestion)}
        >
          Áp dụng
        </Button>
      </div>
    </div>
  );
}
